import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { Cep } from 'src/app/admihair/api/dto/cep';
import { ExceptionDto } from 'src/app/admihair/api/dto/exception/exception-dto';
import { Municipio } from 'src/app/admihair/api/dto/municipio';
import { Uf } from 'src/app/admihair/api/dto/uf';
import { AdministradoraService } from 'src/app/admihair/service/administradora.service';
import { CepService } from 'src/app/admihair/service/cep.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { MunicipioService } from 'src/app/admihair/service/municipio.service';
import { UfService } from 'src/app/admihair/service/uf.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { FormatacaoUtil } from 'src/app/admihair/util/formatacao-util';

@Component({
  selector: 'app-administradora-inserir',
  templateUrl: './administradora-inserir.component.html',
  styleUrls: ['./administradora-inserir.component.scss']
})
export class AdministradoraInserirComponent implements OnInit {

  messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: '' }]; 
  listaUfs: Uf[] = [];
  ufSelecionado?: Uf;
  isUfSelecionada: boolean = false;
  listaMunicipios: Municipio[] = [];
  municipioSelecionado?: Municipio;
  messagemVisivel: boolean = false;
  temDuasPalavras: boolean = false;
  contaPrincipal: boolean = true;
  erroSalvarContato: boolean = false;
  enderecoCep: Cep = {endereco: ' ', bairro: ' '};
  date?: Date;
  exibirMensagemCep:boolean = false;
  bloquearCamposEndereco: boolean = true;
  trocarCamposEndereco: boolean = false;
  modoEdicaoLogradouro: boolean = false;
  modoEdicaoBairro: boolean = false;
  cnpjEncontrado: boolean = false;
  bloqueiaNumeroEComplemento: boolean = true;
  focoCampo: boolean = false;
  dataValida?: boolean = true;

  progressoRequisicao: boolean = false;

  constructor(private administradoraService: AdministradoraService,
    private utilStorageService: UtilStorageService,
    private municipioService: MunicipioService,
    private ufService: UfService,
    private erroService: ErroService,
    private cepService: CepService) { }

  @ViewChild('f') form?: NgForm;
  value?: string;

  ngOnInit(): void {      
    this.listarUfs();
    this.modoEdicaoLogradouro = false;
    this.modoEdicaoBairro = false;
  }

  salvar() {  
    this.progressoRequisicao = true;
    const administradora = this.form?.form.value;;

    administradora.ativo = true;
    administradora.tipo = 'FRANQUIA'
 
    if (this.trocarCamposEndereco) {
      administradora.uf = this.enderecoCep.estado;
      administradora.cidade = FormatacaoUtil.removerCaracteresEspeciais(this.enderecoCep.cidade);
    } else {
      administradora.uf = this.ufSelecionado?.siglaUf;
      administradora.cidade = FormatacaoUtil.removerCaracteresEspeciais(this.municipioSelecionado?.descricao);
      const cepDigitado: Cep = {
        cep: administradora.cep,
        endereco: administradora.logradouro,
        bairro: administradora.bairro,
        cidade: administradora.cidade,
        estado: administradora.uf
      }
      this.salvarCep(cepDigitado);
    }

    this.administradoraService.salvar(administradora).subscribe({
      next: (data: Administradora) => {

        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.limparFormulario();
        this.rolarTela();
      },
      error: (err: any) => {

        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();

      }
    }
    );
  } 



  listarUfs() {
    this.ufService.listarUf().subscribe({
        next: (data: Uf[]) => {
          this.listaUfs = data;
        },
        error: (err: any) => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      }
    )

    const fusoHorarioNavegador = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log(fusoHorarioNavegador);

  }

  listarMunicipios(){
    if(this.ufSelecionado !== undefined && this.ufSelecionado !== null){
      this.isUfSelecionada = true;
      this.municipioService.listarMuniciosPorUf(this.ufSelecionado.codigoUf).subscribe({
          next: (data: Municipio[]) => {
            this.listaMunicipios = data;
          },
          error: (err: any) => {
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        }
      )
    }

  }

  
  consultarCep(){
    var cep = this.form?.value.cep;
    if(cep !== '' && cep !== undefined){
      this.cepService.buscarPorCodigo(cep).subscribe({
        next: (data: Cep) => {
          this.enderecoCep = data;
          if(!this.enderecoCep.endereco){
            this.modoEdicaoLogradouro = true;
            this.exibirMensagemCep = true;
          } else {
            this.modoEdicaoLogradouro = false;
            this.exibirMensagemCep = false;
          }
          if(!this.enderecoCep.bairro){
            this.modoEdicaoBairro = true;
            this.exibirMensagemCep = true;
          } else {
            this.modoEdicaoBairro = false;
            this.exibirMensagemCep = false;
          }
          this.trocarCamposEndereco = true;
          this.bloquearCamposEndereco = true;
          this.bloqueiaNumeroEComplemento = false;
        },
        error: (err: any) => {
          console.log('cep nao encontrado')
          this.enderecoCep = {endereco: ' ', bairro: ' '};
          this.exibirMensagemCep = true;
          this.trocarCamposEndereco = false;
          this.bloquearCamposEndereco = false;
          this.modoEdicaoLogradouro = true;
          this.modoEdicaoBairro = true;
          this.bloqueiaNumeroEComplemento = false;
          this.focoCampo = true;
          

        }
      });
    } else {
      this.bloqueiaNumeroEComplemento = true;
    }
  }

  salvarCep(cep: Cep){
    
    this.cepService.salvar(cep).subscribe({
      next: (data: Cep) => {
        console.log('cep salvo:', data)
      },
      error: (err: any) => {
        console.log('erro ao salvar cep:', err)
      }
    });
  }

  buscarCnpjFranqui(){
    
    const cnpj = this.form?.value.cnpj;

    if(cnpj && cnpj.length === 14){
      this.administradoraService.buscarPorCnpj(cnpj).subscribe({
        next: () => {
          this.cnpjEncontrado = true;
        },
        error: (err: any) => {
          console.log(err);
          this.cnpjEncontrado = false;

        }
      });
    } else {
      console.log('cnpj inválido ou vazio')
      this.cnpjEncontrado = false;
    }
   
  }

  liberaCampo(item: string): boolean {
    return item ? true : false;
  }
  camposPreenchendo(){
    this.exibirMensagemCep = false;
  }
 
  tratarErroApi(exceptions: ExceptionDto[]) {
    if(exceptions.length > 0){
      this.messages = [{ severity: 'error', summary: exceptions[0].requestId, detail: exceptions[0].data[0].message }];
    }
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }

  limparFormulario(){
    this.form?.reset();
    this.isUfSelecionada = false;  
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  ocultarMsg(){
    this.messagemVisivel = false;
  }
  
}
